<a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" class="t-ellipsis">
  @if (showPlacehoder) {
  <span>{{ placeholder }}</span>
  } @if (form.value.adult) {
  <span class="m-r-8"
    >{form.value.adult, plural, =1 {{{form.value.adult}} adult} other
    {{{form.value.adult}} adults}}</span
  >
  } @if (form.value.student) {
  <span class="m-r-8"
    >{form.value.student, plural, =1 {{{form.value.student}} student} other
    {{{form.value.student}} students}}</span
  >
  } @if (form.value.child) {
  <span class="m-r-8"
    >{form.value.child, plural, =1 {{{form.value.child}} child} other
    {{{form.value.child}} children}}</span
  >
  } @if (form.value.infant) {
  <span class="m-r-8"
    >{form.value.infant, plural, =1 {{{form.value.infant}} infant} other
    {{{form.value.infant}} infants}}</span
  >
  }
</a>
@if (infoText) {
<span class="t-small c-soft">{{ infoText }}</span>
}
<nz-dropdown-menu #menu="nzDropdownMenu">
  <form class="un-card" [formGroup]="form">
    <div class="input-wrapper m-b-24">
      <label i18n>Adults</label>
      <nz-input-group
        [nzPrefix]="minusAdult"
        [nzSuffix]="addAdult"
        nzSize="small"
      >
        <input nz-input formControlName="adult" />
      </nz-input-group>
    </div>
    @if (!hideStudent) {
    <div class="input-wrapper m-b-24">
      <label i18n>Students</label>
      <nz-input-group
        [nzPrefix]="minusStudent"
        [nzSuffix]="addStudent"
        nzSize="small"
      >
        <input nz-input formControlName="student" />
      </nz-input-group>
    </div>
    }
    <div class="input-wrapper m-b-24">
      <label i18n>Children</label>
      <nz-input-group
        [nzPrefix]="minusChild"
        [nzSuffix]="addChild"
        nzSize="small"
      >
        <input nz-input formControlName="child" />
      </nz-input-group>
    </div>
    @if (!hideInfact) {
    <div class="input-wrapper">
      <label i18n>Infants</label>
      <nz-input-group
        [nzPrefix]="minusInfant"
        [nzSuffix]="addInfant"
        nzSize="small"
      >
        <input nz-input formControlName="infant" />
      </nz-input-group>
    </div>
    }
  </form>
</nz-dropdown-menu>
<ng-template #addAdult>
  <span class="c-primary action" (click)="incr(PASSANGER_TYPE.adult)">+</span>
</ng-template>
<ng-template #minusAdult>
  <span class="c-primary action" (click)="decr(PASSANGER_TYPE.adult)">-</span>
</ng-template>
<ng-template #addStudent>
  <span class="c-primary action" (click)="incr(PASSANGER_TYPE.student)">+</span>
</ng-template>
<ng-template #minusStudent>
  <span class="c-primary action" (click)="decr(PASSANGER_TYPE.student)">-</span>
</ng-template>
<ng-template #addChild>
  <span class="c-primary action" (click)="incr(PASSANGER_TYPE.child)">+</span>
</ng-template>
<ng-template #minusChild>
  <span class="c-primary action" (click)="decr(PASSANGER_TYPE.child)">-</span>
</ng-template>
<ng-template #addInfant>
  <span class="c-primary action" (click)="incr(PASSANGER_TYPE.infant)">+</span>
</ng-template>
<ng-template #minusInfant>
  <span class="c-primary action" (click)="decr(PASSANGER_TYPE.infant)">-</span>
</ng-template>
